import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          background: `radial-gradient(ellipse at top, ${scrollY < 200 ? '#1a100520' : '#0a0a0a'} 0%, #0a0a0a 70%)`,
        }}
      />
      <div className="relative z-10">
        <Hero />
        <Services />
        <Gallery />
        <About />
        <Contact />
        <Footer />
      </div>

      {/* Floating call button on mobile */}
      <a
        href="tel:262-215-0688"
        className="fixed bottom-6 right-6 z-50 sm:hidden bg-orange-500 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-xl shadow-orange-500/40 hover:bg-orange-600 transition-all duration-200"
        aria-label="Call now"
      >
        <i className="ri-phone-fill text-2xl"></i>
      </a>
    </div>
  );
}
